import React, { useState } from 'react'
import SelectDataForms from '../../../components/select/dataforms';
import { ResultTable } from '../../results';

const AnalysisResult = () => {
    const [data, setData] = useState({ name: -1 });
    return (
        <>
            <SelectDataForms title="Select Result Type" value={data.name} setValue={(name) => setData({ name })} />
            <div>{data.name !== -1 && <ResultTable key={data.name} name={data.name} />}</div>
        </>
    )
}

export default AnalysisResult